import React from 'react'
import Choose from '../page/Choose'
import Pack from '../page/Pack'
import Package from '../page/Package'
import Popular from '../page/Popular'
import Snap from '../page/Snap'
import Travel from '../page/Travel'

function Home() {
  return (
    
    <div>
      <Popular/>
      <Travel/>
      <Choose/>
      <Pack/>
      <Package/>
      <Snap/>
    </div>
  )
}

export default Home
